module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Regular.ttf?v=1d0778c0353a43a8a6e71c5e8310f38d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Regular.ttf
// module id = 670
// module chunks = 0